import {
    getCachedLivestream, getCachedProcurement, getInventory, getLivestream, getLivestreams,
    getProcurement, getProcurements,
} from '../../api/erp';
import { getErpRole } from './erpAccess';

/** Warm only the destination's first page on navigation intent.
 * Uses the normal scoped read cache (same URL, TTL and write invalidation).
 * Failures are handled by the destination's normal read/retry UI.
 */
/** First page of the live list. Each live row sums pricing over all of its items on
 * the server, so a screenful (plus infinite-scroll prefetch) is loaded at a time. */
export const LIVE_LIST_PAGE_SIZE = 20;

export function prefetchErpNavigation(path: string | null) {
    if (getErpRole() !== 'admin') return;
    const page = { page: 1, per_page: 50 };
    const request = path === '/erp/live' ? getLivestreams({ page: 1, per_page: LIVE_LIST_PAGE_SIZE })
        : path === '/erp/purchase' ? getProcurements(page)
        : path === '/erp/inventory' ? getInventory(page)
        : null;
    void request?.catch(() => {});
}

// The detail pages seed from these exact reads (live workspace view; procurement
// page 1 × 50 with no filters) and still revalidate on mount.
const DETAIL_SNAPSHOT_FRESH_MS = 30_000;

export function prefetchLivestreamDetail(id: number) {
    if (getErpRole() !== 'admin' || getCachedLivestream(id, DETAIL_SNAPSHOT_FRESH_MS)) return;
    void getLivestream(id, { view: 'workspace' }).catch(() => {});
}

export function prefetchProcurementDetail(id: number) {
    const params = { page: 1, perPage: 50 };
    if (getErpRole() !== 'admin' || getCachedProcurement(id, params)) return;
    void getProcurement(id, params).catch(() => {});
}
